import styled from 'styled-components'
import { TopContainerHeight } from '~/constants'

export const Container = styled.div`
  position: relative;
  display: flex;
  height: calc(100vh - ${TopContainerHeight});
  width: 100%;
  background: ${props => props.theme.colors.colorf3f5f9} 0% 0% no-repeat padding-box;
  padding-left: 70px;
`

export const SidemenuContainer = styled.nav`
  position: fixed;
  left: 0;
  top: 0;
  width: 70px;
  height: 100%;
  margin: 0;
  padding: 10px;

  display: flex;
  z-index: 9999;
  flex-direction: column;
  align-items: start;

  box-shadow: 0 3px 6px ${props => props.theme.colors.colorBlack29};
  background: ${props => props.theme.colors.color122d52};
  transition:
    width 0.5s,
    padding 0.2s;
`

export const ButtonIcon = styled.button`
  position: relative;
  display: flex;
  text-decoration: none;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
  width: auto;
  background: transparent;
  margin-top: 14px;
  border: none;

  cursor: pointer;
  outline: none;
  transition:
    background 0.2s,
    padding 0.2s;
  transition-delay: 1s, 0s;

  svg {
    width: 20px;
    height: 20px;
    stroke: ${props => props.theme.colors.color9ba8ba};
    transition: stroke 0.5s;
  }

  &:hover {
    svg {
      stroke: ${({ theme }) => theme.zds.colors.neutral1000};
    }
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 41px;
    border-radius: 4px;
    background: transparent;
    color: ${props => props.theme.colors.color9ba8ba};
    transition: background 0.2s;
  }
`

export const Content = styled.div`
  position: relative;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
